<form #materialForm="ngForm" (ngSubmit)="onFormSubmit()">
  <div class="form-container">
    <mat-form-field class="form-field form-field--full-width">
      <input [(ngModel)]="model.description" i18n-placeholder id="description" matInput name="description"
             placeholder="Description"
             required type="text">
    </mat-form-field>
    <mat-form-field class="form-field">
      <mat-select [(ngModel)]="model.unit" i18n-placeholder name="unit" placeholder="Unit" required>
        @for (u of unities; track u) {
          <mat-option [value]="u">
            {{ u }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class="form-field">
      <input [(ngModel)]="model.quantity" i18n-placeholder id="quantity" matInput name="quantity"
             placeholder="Quantity"
             required type="number">
    </mat-form-field>
    <mat-form-field class="form-field">
      <input [(ngModel)]="model.costEach" i18n-placeholder id="costEach" matInput name="costEach"
             placeholder="Cost Each"
             required type="number">
    </mat-form-field>
    <mat-form-field class="form-field">
      <mat-select [(ngModel)]="model.category" i18n-placeholder name="category" placeholder="Category">
        @for (cat of categories; track cat) {
          <mat-option [value]="cat.name">
            {{ cat.description }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (forOrderBuild) {
      <mat-form-field class="form-field form-field--full-width">
        <mat-select (selectionChange)="changeRef($event)" i18n-placeholder placeholder="Assign to existing material">
          @for (mat of assignPossibilities; track mat) {
            <mat-option [value]="mat.id">
              {{ mat.description }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  </div>
  <div class="button-row">
    <button [disabled]="!materialForm.form.valid" i18n mat-raised-button
            type="submit">{{ editMode && type !== 'copy' ? 'Update material' : 'Add material' }}
    </button>
    <button i18n mat-dialog-close mat-raised-button type="button">Cancel</button>
  </div>
</form>